export default [
  {
    path: '/relGraficoBalancoDiario/',
    name: 'relGraficoBalancoDiario',
    title: 'relGraficoBalancoDiario',
    component: () => import('../views/RelGraficoBalancoDiarioView.vue'),
    redirect: { name: 'relGraficoBalancoDiario-listar' },
    children: [
      {
        path: 'welcome',
        name: 'relGraficoBalancoDiario-listar',
        component: () => import('../views/RelGraficoBalancoDiarioWelcomeView.vue'),
        meta: {
          title: 'Gráfico de balanço diário',
        },
      },
    ],
  },
];
